'use client';

import { fetchReferences } from '@eliadmin/core/src/api/references/references-api';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { ReferenceCard } from './reference-card';

export const ReferencesList = () => {
  const { t } = useTranslations();
  const locale = useLocaleStore(s => s.currentLocale);
  const referencesQuery = useSuspenseInfiniteQuery({
    queryKey: ['references'],
    queryFn: ({ pageParam = 1 }) =>
      fetchReferences({
        locale,
        limit: 20,
        page: pageParam,
      }),
    getNextPageParam: (lastPage: any) => {
      if (lastPage?.meta?.current_page < lastPage?.meta?.last_page)
        return lastPage?.meta?.current_page + 1;
      return undefined;
    },
    initialPageParam: 1,
  });

  const references = referencesQuery.data?.pages.flatMap((page: any) => page.data) ?? [];

  return (
    <>
      <div className="grid w-full max-w-[1280px] grid-cols-1 gap-x-10 gap-y-[120px] sm:gap-y-[180px] md:grid-cols-2">
        {references.map(reference => (
          <ReferenceCard reference={reference} key={reference.name} />
        ))}
      </div>
      <div
        className={cn('', 'ea-references-page__show-more-div', {
          hidden: !referencesQuery.hasNextPage,
        })}
      >
        <Button
          onClick={() => referencesQuery.fetchNextPage()}
          isLoading={referencesQuery.isFetchingNextPage}
          className="text-white"
        >
          {t('text338')}
        </Button>
      </div>
    </>
  );
};
